import { useLanguage } from '@/context/LanguageContext';
import common from './i18n/common';
import vps from './i18n/vps';
import dedicated from './i18n/dedicated';
import gameservers from './i18n/gameservers';
import rootserver from './i18n/rootserver';
import services from './i18n/services';
import webhosting from './i18n/webhosting';
import productFinder from './i18n/productFinder';

const translations = {
  en: {
    ...common.en,
    ...vps.en,
    ...dedicated.en,
    ...gameservers.en,
    ...rootserver.en,
    ...services.en,
    ...webhosting.en,
    ...productFinder.en,
  },
  de: {
    ...common.de,
    ...vps.de,
    ...dedicated.de,
    ...gameservers.de,
    ...rootserver.de,
    ...services.de,
    ...webhosting.de,
    ...productFinder.de,
  },
};

// ── Hook ─────────────────────────────────────────────────────────────────────
export const useTranslation = () => {
  const { lang } = useLanguage();

  const t = (key) => {
    const keys = key.split('.');
    // Try current language first
    let value = translations[lang];
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        value = null;
        break;
      }
    }
    if (value && typeof value === 'string') return value;

    // Fallback to English
    let fallback = translations['en'];
    for (const k of keys) {
      if (fallback && typeof fallback === 'object' && k in fallback) {
        fallback = fallback[k];
      } else return key; // Return key as last resort
    }
    return (fallback && typeof fallback === 'string') ? fallback : key;
  };

  return { t, lang };
};

export default translations;
